import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yjgecwdpju: FaireBrandEntity = {
  token: "b_yjgecwdpju",
  type: "brand",
  name: "WHOLIFECO",
  avatarUrl:
    "https://cdn.faire.com/fastly/29b2552fd3571f85c8db52745fe4bc830dae6c078ac10c79c51984a15d2cd21c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5ad9af803fbd7884c532ed4471f073b6b4556b5b1e85f4f283218ebb737d6a3f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/29b2552fd3571f85c8db52745fe4bc830dae6c078ac10c79c51984a15d2cd21c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5ad9af803fbd7884c532ed4471f073b6b4556b5b1e85f4f283218ebb737d6a3f.jpeg",
  location: "Springfield,, OH, USA",
  minimumOrderDollars: 125,
  rating: 3.7,
  reviewCount: 6,
  isInsider: true,
  description:
    "At Wholifeco, we believe in the transformative power of nature to heal, inspire, and elevate everyday life. Born from a passion for holistic living, our brand is rooted in the principles of balance, wellness, and sustainability. Every product we create is a reflection of our commitment to crafting high-quality, natural solutions for the modern world.\n\nWe specialize in natural wellness products, handcrafted candles, herbal teas, and more, offering a curated selection designed to bring comfort, harmony, and a touch of serenity into your life. From nourishing tea blends that support the body and mind to soothing balms and aromatic candles that enhance your space, Wholifeco is dedicated to fostering wellness in every way.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:46.067Z",
    importedBy: "entity-db-cli",
  },
};
